import React from 'react'
import { Link, useLocation } from 'react-router-dom'
// import { PUBLIC_URL } from '../../config/constant';
import { Home } from "lucide-react"

export default function BreadCrumb({ title, header, subHeader, subHeaderOnlyView }) {
    const location = useLocation();
    const path = location?.pathname
    let splitPath = path?.split('/')

    return (
        <>
            {/* <div className="row">
                <div className="col-12">
                    <div className="page-title-box">
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className='linkdata'><i className="bi bi-house-door"></i>&nbsp;</li>
                                <li className="breadcrumb-item"><Link to="/" className='linkdata'>Dashboard</Link></li>
                                <li className="breadcrumb-item"><Link to={'/' + splitPath?.[1]}>{header}</Link></li>
                                {subHeader ?
                                    <li className="breadcrumb-item"><Link to={path}>{subHeader}</Link></li> : <></>
                                }
                                {subHeaderOnlyView ?
                                    <li className="breadcrumb-item active"><a>{subHeaderOnlyView}</a></li> : <></>
                                }
                            </ol>
                        </div>
                        <h4 className="page-title">{title}</h4>
                    </div>
                </div>
            </div> */}

            <div className="w-full bg-gray-100 rounded-md shadow-sm mb-3 mt-4">
                <div className="max-w-7xl mx-auto px-4 py-3">
                    <nav className="flex items-center text-sm text-gray-700 space-x-1 flex-wrap" aria-label="Breadcrumb">
                        <Link to="/dashboard" className="flex items-center space-x-1 font-medium hover:text-blue-600">
                            <Home className="w-4 h-4" />
                            <span className="ml-1">Home</span>
                        </Link>
                        {/* {header && (
                            <li className="before:content-['/'] before:mx-2">
                                <Link to={`/${splitPath?.[1]}`} className="hover:text-blue-600">
                                    {header}
                                </Link>
                            </li>
                        )} */}
                        {subHeader && (
                            <>
                                <span>/</span>
                                <Link to={path} className="hover:text-blue-600">
                                    {subHeader}
                                </Link>
                            </>
                        )}

                        {subHeaderOnlyView && (
                            <>
                                <span>/</span>
                                <span className="font-medium text-gray-500 font-medium">{subHeaderOnlyView}</span>
                            </>
                        )}
                    </nav>
                </div>
            </div>

        </>
    )
}
